import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

const JobListPage = lazy(() => import('views/job-list'));
const JobDetailPage = lazy(() => import('views/job-detail'));
const HomePage = lazy(() => import('views/home'));
const CompanyDetailPage = lazy(() => import('views/company-detail'));
const JobseekerDetailPage = lazy(() => import('views/jobseeker-detail'));
const CompanyListPage = lazy(() => import('views/company-list'));
const BlogListPage = lazy(() => import('views/blog-list'));
const BlogDetailPage = lazy(() => import('views/blog-detail'));
const JobseekerListPage = lazy(() => import('views/jobseeker-list'));
const PricingPage = lazy(() => import('views/pricing'));
const AboutPage = lazy(() => import('views/about'));
const PrivacyPolicyPage = lazy(() => import('views/privacy-policy'));
const PaymentSuccess = lazy(() => import('views/payment-state/payment-success'));
const PaymentFailed = lazy(() => import('views/payment-state/payment-failed'));
const PaymentCancelled = lazy(() => import('views/payment-state/payment-cancelled'));
const VerifyPage = lazy(() => import('views/auth/verify'));
const ResetPasswordPage = lazy(() => import('views/auth/reset-password'));
const NotFoundPage = lazy(() => import('views/not-found'));
const SignInPage = lazy(() => import('views/auth/sign-in-page'));
const SignUpJobseekerPage = lazy(() => import('views/auth/sign-up-jobseeker'));
const SignUpEmployerPage = lazy(() => import('views/auth/sign-up-employer'));
const ForgotPasswordPage = lazy(() => import('views/auth/forgot-password-page'));

const AppRouter: React.FC = () => {
    return (
        <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/jobs" component={JobListPage} />
            <Route exact path="/companies" component={CompanyListPage} />
            <Route exact path="/blog" component={BlogListPage} />
            <Route exact path="/blog/:slug" component={BlogDetailPage} />
            <Route exact path="/pricing" component={PricingPage} />
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/job/:slug" component={JobDetailPage} />
            <Route exact path="/company/:id" component={CompanyDetailPage} />
            <Route exact path="/jobseeker/:id" component={JobseekerDetailPage} />
            <Route exact path="/jobseekers" component={JobseekerListPage} />
            <Route exact path="/verify" component={VerifyPage} />
            <Route exact path="/reset-password" component={ResetPasswordPage} />
            <Route exact path="/sign-in" component={SignInPage} />
            <Route exact path="/sign-up-jobseeker" component={SignUpJobseekerPage} />
            <Route exact path="/sign-up-employer" component={SignUpEmployerPage} />
            <Route exact path="/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/privacy-policy" component={PrivacyPolicyPage} />
            <Route exact path="/payment-success" component={PaymentSuccess} />
            <Route exact path="/payment-failed" component={PaymentFailed} />
            <Route exact path="/payment-cancelled" component={PaymentCancelled} />
            <Route exact path="/404" component={NotFoundPage} />
            <Route exact path="/:slug" component={CompanyDetailPage} />
            <Redirect from="*" to="/404" />
        </Switch>
    );
};
export default AppRouter;
